import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
import { passFailState, passFailMutations } from '@/../../troubleshooter/src/store/common/passFail'

const cameraModule = {
  namespaced: true,
  state: {
    ...passFailState,
    camInstalled: false,
    explainer: [
      _('To join a class you must also \'allow\' access to your camera. Click to test.')
    ],
    title: _('Step 3: Test Your Camera'),
    nextPage: '#/connection/',
    previousPage: '#/microphone/',
    callToAction: {
      'text': _('Test Camera')
    },
    questionId: 'camera',
    disabled: false
  },

  mutations: {
    ...passFailMutations,

    isCamInstalled (state) {
      state.camInstalled = true
    },

    disableCam (state) {
      state.disabled = true
    }
  }
}

export default cameraModule
